import type { SVGProps } from 'react';

export const SquareAndArrowDownSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 18.0099 24.5582"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="24.5582" opacity="0" width="18.0099" x="0" y="0" />{' '}
        <path
          d="M17.6486 11.2504L17.6486 18.7787C17.6486 21.4627 16.1451 22.9662 13.4549 22.9662L4.1875 22.9662C1.49551 22.9662 0 21.4627 0 18.7787L0 11.2504C0 8.5584 1.49551 7.06465 4.1875 7.06465L6.07754 7.06465L6.07754 8.97791L4.23671 8.97791C2.75292 8.97791 1.91327 9.81932 1.91327 11.3014L1.91327 18.7277C1.91327 20.2115 2.75292 21.0529 4.23671 21.0529L13.4057 21.0529C14.8957 21.0529 15.7354 20.2115 15.7354 18.7277L15.7354 11.3014C15.7354 9.81932 14.8957 8.97791 13.4057 8.97791L11.5711 8.97791L11.5711 7.06465L13.4549 7.06465C16.1451 7.06465 17.6486 8.5584 17.6486 11.2504Z"
          fill="currentColor"
        />{' '}
        <path
          d="M8.82831 1.84297C8.33281 1.84297 7.92051 2.24804 7.92051 2.72499L7.92051 12.5266L8.07988 15.3355C8.10644 15.7443 8.41953 16.076 8.82831 16.076C9.23085 16.076 9.54394 15.7443 9.5705 15.3355L9.72811 12.5266L9.72811 2.72499C9.72811 2.24804 9.32382 1.84297 8.82831 1.84297ZM5.46933 11.6047C5.02226 11.6047 4.66953 11.9248 4.66953 12.3814C4.66953 12.6226 4.76621 12.7982 4.92851 12.9605L8.14414 16.0555C8.37636 16.2842 8.58632 16.3586 8.82831 16.3586C9.0623 16.3586 9.27401 16.2842 9.50448 16.0555L12.7201 12.9605C12.8842 12.7982 12.9791 12.6226 12.9791 12.3814C12.9791 11.9248 12.6103 11.6047 12.1713 11.6047C11.9426 11.6047 11.7244 11.6969 11.5684 11.8725L10.1689 13.3607L8.82831 14.9799L7.47968 13.3607L6.08027 11.8725C5.92421 11.6969 5.69804 11.6047 5.46933 11.6047Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
